// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MIC_2020_COMPANY_LOADING() {
      return {
        isLoading: true
      };
    },
    MIC_2020_COMPANY_LOADED() {
      return {
        isLoading: false,
        companies: action.micCompanies
      };
    },
    MIC_2020_COMPANY_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
